<div class="main-toolbar" style="background-color: #121212;">
  <div class="container-fluid d-flex align-items-center">
<!-- <span>
    <button mat-mini-fab color="primary" (click)="sidenav.toggle()">
      <i class="las la-bars"></i>
    </button>
  </span> -->
  <span style="font-size: 16px;font-weight:500;color:#111">

    <img src="./assets/images/LogoHeader.svg" width="200px">
  </span>
  <span class="spacer">

    <mat-nav-list class=" t-menu list-horizontal p-0" [ngClass]="{'d-flex':toggler}">
      <!-- <a mat-list-item [routerLink]="['/main/dashboard']" [routerLinkActive]="'active'">DASHBOARD</a> -->
      <a mat-list-item [routerLink]="['/main/shipments']" [routerLinkActive]="'active'">SHIPMENTS</a>
      <a mat-list-item [routerLink]="['/main/sale-orders']" [routerLinkActive]="'active'">SALE ORDERS</a>
      <a mat-list-item [routerLink]="['/main/rates-setup']" [routerLinkActive]="'active'">RATES SETUP</a>
      <a mat-list-item [routerLink]="['/main/product']" [routerLinkActive]="'active'">PRODUCT DIMENSIONS</a>
      <!-- <a mat-list-item href="#">PICK-UP</a> -->
    </mat-nav-list>
  </span>
  <span class="d-flex">
    <button [matMenuTriggerFor]="menu" style="color: #ddd;" mat-button> <img class="profile-img" src="./assets/images/thumbnail.jpg"> </button>
    <mat-menu #menu="matMenu">
      <!-- <button mat-menu-item >Profile</button>
      <button mat-menu-item >Personal Information</button> -->
      <button mat-menu-item (click)="logout()">Sign out</button>
    </mat-menu>
  </span>
  <span class="t-menu-drop" (click)="toggler=!toggler">
    <i class="icon-options-vertical"></i>
  </span>
  </div>
  
</div>
<div>

</div>
<mat-sidenav-container class="example-container">

  <mat-sidenav-content class="content pad">
    <div class="container-fluid">
      <router-outlet></router-outlet>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>